import React from "react";
import { useTranslation } from "react-i18next";
import InputAutoresize from "../../../../common/components/form/InputAutoresize.jsx";
import InputSelect from "../../../../common/components/form/InputSelect.jsx";
import { PayPalCurrencies, PayPalCurrenciesValues } from "../../../../common/constant/paypal.js";
import InputRadio from "../../../../common/components/form/InputRadio.jsx";
import InputBase from "../../../../common/components/form/InputBase.jsx";

const ShimpentTypes = {
    Physically: {
        value: "physically",
        t_text: "Product must be shipped physically",
    },
    Digitally: {
        value: "digitally",
        t_text: "Product must be shipped digitally",
    },
};

export default function PricingSettings(props) {
    const { t } = useTranslation();

    const {
        set,
        variables,
        variables: { ShipmentType, ProductLink, EmailNotification },
    } = props;

    React.useEffect(() => {
        if (!ShipmentType) {
            set({ ...variables, ShipmentType: ShimpentTypes.Physically.value });
        }
    }, [variables]);

    function onShipmentTypeChange(value) {
        set({ ...variables, ShipmentType: value });
    }

    function onEmailNotificationChange(event) {
        let value = event.target.value;
        event.type === "blur" && (value = value.trim());
        set({ ...variables, EmailNotification: value });
    }

    function onProductLinkChange(event) {
        let value = event.target.value;
        event.type === "blur" && (value = value.trim());
        set({ ...variables, ProductLink: value });
    }

    return (
        <div className="grid-gap-20 align-content-start text-left">
            <h3>{t("Shipment Type")}:</h3>

            <p>
                {t(
                    "Indicate whether your product should be delivered to the customer physically or you can provide a link to receive a digital product"
                )}
            </p>

            {Object.values(ShimpentTypes).map(({ value, t_text }) => (
                <React.Fragment key={value}>
                    <InputRadio value={value} checked={ShipmentType === value} onChange={onShipmentTypeChange}>
                        {t(t_text)}
                    </InputRadio>
                </React.Fragment>
            ))}

            {ShipmentType === ShimpentTypes.Digitally.value && (
                <InputBase
                    onChange={onProductLinkChange}
                    onBlur={onProductLinkChange}
                    value={ProductLink || ""}
                    placeholder={t("InsertProductLinkHere")}
                    fullWidth
                />
            )}

            <h3>{t("Email Notification For Your Clients")}:</h3>

            <p>
                {t(
                    "Place here a message to send to your customers after they made a successful purchase. This message will be displayed alongside with the order information"
                )}
            </p>

            <InputAutoresize
                onChange={onEmailNotificationChange}
                onBlur={onEmailNotificationChange}
                value={EmailNotification || ""}
                // placeholder={t("Generated by GPT")}
                fullWidth
                multirow
                rows={8}
            />
        </div>
    );
}
